export enum PopupContentType {
  SMTH_WENT_WRONG = 'SMTH_WENT_WRONG',
  INTERNET_CONNECTION_ISSUES = 'INTERNET_CONNECTION_ISSUES',
}

export interface PopupCustomProps {
  content: PopupContentType;
}
